import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
 Component,
 HostListener,
 Inject,
 InjectionToken,
 OnInit,
 PLATFORM_ID,
 Signal,
 WritableSignal,
 afterNextRender,
 effect,
 inject,
} from '@angular/core';
import {
 RouterModule,
 ActivatedRoute,
 Router,
 NavigationEnd,
 NavigationStart,
} from '@angular/router';
import { GetUserProfileResponse } from '@core/models/DTOs/userProfile.dto';
import { AuthService } from '@core/services/authentication/auth.service';
import { FooterFeaturesComponent } from '@shared/components/footer/features/features.component';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { SideMenuComponent } from '@shared/components/side-menu/side-menu.component';
import { TopNavComponent } from '@shared/components/top-nav/top-nav.component';
import { SharedModule } from '@shared/shared.module';
import { SideFiltersComponent } from 'apps/ihowebsite/src/app/pages/search-result/components/side-filters/side-filters.component';
import { LoginRegisterUiService } from '../../../pages/login-register/login-register-ui.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginRegisterModule } from '../../../pages/login-register/login-register.module';
import { UserProfileRepository } from '@core/services/repositories/userProfile.repository';
import { filter, Observable } from 'rxjs';
import { NotFoundComponent } from '../../../pages/notfound/notfound.component';
import { TransferState, makeStateKey } from '@angular/platform-browser';

export const WINDOW = new InjectionToken<Window>('Window', {
 providedIn: 'root',
 factory: () => window,
});

@Component({
 selector: 'iho-website',
 templateUrl: './website.component.html',
 styleUrls: ['./website.component.scss'],
 standalone: true,
 imports: [
  CommonModule,
  RouterModule,
  TopNavComponent,
  FooterComponent,
  FooterFeaturesComponent,
  LoginRegisterModule,
  SideMenuComponent,
  SideFiltersComponent,
  SharedModule,
  NotFoundComponent,
 ],
 providers: [
  {
   provide: WINDOW,
   useFactory: (platformId: Object) => {
    return isPlatformBrowser(platformId) ? window : {};
   },
   deps: [PLATFORM_ID],
  },
 ],
})


export class WebsiteLayoutComponent implements OnInit {
    IS_MAP_ROUTE_KEY = makeStateKey<boolean>('isInMapPage');
 showHeaderSearch = false;
 drawerIsOpen = false;
 drawerIsOpenFilters = false;
 showTop = false;
 _isLoadingAuth!: WritableSignal<boolean>;
 userData!: WritableSignal<GetUserProfileResponse>;
 phoneNumber: string = '';
 isInMapPage = false;
 isPlatformBrowser!: boolean;
 resPhoneApi!: Observable<any>;
    transferState = inject(TransferState);

 constructor(
  public LoginRegisterUiService: LoginRegisterUiService,
  public authSrvc: AuthService,
  public activatedRoute: ActivatedRoute,
  public dialog: MatDialog,
  public router: Router,
  public route: ActivatedRoute,
  public userRepo: UserProfileRepository,
  @Inject(WINDOW) private window: Window,
  @Inject(DOCUMENT) private document: Document,
  @Inject(PLATFORM_ID) private platformId: Object
 ) {
  this.isPlatformBrowser = isPlatformBrowser(platformId);
  afterNextRender(() => {
   this.resPhoneApi = this.userRepo.GetConfigData();
   if (location.href.includes('/map')) this.isInMapPage = true;

  
  });

  effect(() => {
   this.userData = this.authSrvc.getUserData();
   this._isLoadingAuth = this.authSrvc._isLoadingAuth;
  });

  afterNextRender(() => {
   this.resPhoneApi = this.userRepo.GetConfigData();
  });
 }

 toggleDrawer(e: boolean) {
  this.drawerIsOpen = e;
 }

 @HostListener('window:scroll', ['$event'])
 onWindowScroll(e: Event) {
  if (isPlatformBrowser(this.platformId)) {
   if (this.document.documentElement.scrollTop > 700) this.showTop = true;
   else this.showTop = false;
  }
 }

 ngOnInit() {
  this.LoginRegisterUiService.monitorRouteChanges();
     // handled ssr and csr header and footer show with flag isInMapPage
     if (this.transferState.hasKey(this.IS_MAP_ROUTE_KEY)) {
         this.isInMapPage = this.transferState.get(this.IS_MAP_ROUTE_KEY, false);
     } else {
         this.isInMapPage = this.router.url.includes('/map');
         this.transferState.set(this.IS_MAP_ROUTE_KEY, this.isInMapPage);
     }    
     if (isPlatformBrowser(this.platformId)) {      
         this.router.events.pipe(
             filter(event => event instanceof NavigationEnd)
         ).subscribe(() => {
             this.isInMapPage = this.router.url.includes('/map');
         });
     }

 }
 

 goToTop() {
  if (isPlatformBrowser(this.platformId)) {
   this.window.scrollTo({
    top: 0,
    behavior: 'smooth',
   });
  }
 }

 goToRayaChat() {}

 goToChat() {}
}
